import { useCallback, useRef, useState } from 'react';
const CLOSED_STATE = {
    anchorEl: null,
    onInsert: null,
    onDismiss: null
};
export function useVariablePicker() {
    const [pickerState, setPickerState] = useState(CLOSED_STATE);
    const dismissRef = useRef(null);
    const openPicker = useCallback((anchorEl, onInsert, onDismiss)=>{
        var _dismissRef_current;
        (_dismissRef_current = dismissRef.current) === null || _dismissRef_current === void 0 ? void 0 : _dismissRef_current.call(dismissRef);
        dismissRef.current = onDismiss !== null && onDismiss !== void 0 ? onDismiss : null;
        setPickerState({
            anchorEl,
            onInsert,
            onDismiss: onDismiss !== null && onDismiss !== void 0 ? onDismiss : null
        });
    }, []);
    const closePicker = useCallback(()=>{
        dismissRef.current = null;
        setPickerState(CLOSED_STATE);
    }, []);
    return {
        pickerState,
        openPicker,
        closePicker
    };
}
